import { useAppContext } from "../context";

const useCompanyReportsService = () => {
  const { isProd } = useAppContext();

  const getBaseUrl = () => {
    return isProd
      ? "https://mission-control.api.onoranzefunebricloud.com"
      : "https://mission-control.api.dev-onoranzefunebricloud.com";
  };

  const requestReport = async (vatNumber, token) => {
    const response = await fetch(`${getBaseUrl()}/company-reports/request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ vatNumber }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  };

  const getReports = async (params = {}, token) => {
    const searchParams = new URLSearchParams();
    
    if (params.vatNumber) searchParams.append("vatNumber", params.vatNumber);
    if (params.status) searchParams.append("status", params.status);
    if (params.limit) searchParams.append("limit", params.limit.toString());
    if (params.offset) searchParams.append("offset", params.offset.toString());

    const response = await fetch(`${getBaseUrl()}/company-reports?${searchParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  };

  const getReportDetails = async (reportId, token, includeFullData = false) => {
    const searchParams = new URLSearchParams();
    if (includeFullData) searchParams.append("includeFullData", "true");

    const response = await fetch(`${getBaseUrl()}/company-reports/${reportId}?${searchParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  };

  return {
    requestReport,
    getReports,
    getReportDetails,
  };
};

export default useCompanyReportsService;